import React from "react";

const CATEGORIES = [
    {
        title: "Régies publicitaires",
        items: [
            "Google Ads",
            "Meta Ads (Facebook & Instagram)",
            "TikTok Ads",
            "LinkedIn Ads",
            "X / Twitter Ads",
            "Microsoft Ads",
            "Snapchat Ads",
            "Pinterest Ads",
            "Spotify Ads",
        ],
    },
    {
        title: "Données & analytique",
        items: [
            "Google Analytics 4",
            "Looker Studio",
            "Excel & Google Sheets",
            "Airtable",
            "Monday",
        ],
    },
    {
        title: "Développement",
        items: ["JavaScript", "Angular", "PHP", "WordPress"],
    },
];

const CERTS = [
    "Google Ads — Réseau de Recherche",
    "Google Ads — Vidéo",
    "Meta Digital Marketing Associate",
    "Teads Academy — Traffic Acquisition",
    "CISCO Networking",
];

const LANGS = [
    { name: "Français", level: "Langue maternelle" },
];

export default function Skills() {
    return (
        <section
            id="competences"
            data-testid="skills-section"
            className="relative py-28 md:py-36 border-t border-[#e8e4dd]"
        >
            <div className="max-w-[1400px] mx-auto px-5 md:px-10">
                <div className="mb-16 max-w-3xl">
                    <p className="label-eyebrow mb-5">— 05 / Outils & savoir-faire</p>
                    <h2
                        className="font-serif text-5xl md:text-6xl tracking-tight text-[#0e0e0c]"
                        style={{ fontWeight: 400 }}
                    >
                        Une boîte à outils{" "}
                        <span className="italic-serif">bien rangée.</span>
                    </h2>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-3 gap-10 lg:gap-16">
                    {CATEGORIES.map((cat) => (
                        <div
                            key={cat.title}
                            data-testid={`skill-cat-${cat.title}`}
                            className="border-t border-[#0e0e0c] pt-6"
                        >
                            <h3
                                className="font-serif text-2xl md:text-3xl text-[#0e0e0c] mb-7"
                                style={{ fontWeight: 400 }}
                            >
                                {cat.title}
                            </h3>
                            <ul className="space-y-3">
                                {cat.items.map((s, i) => (
                                    <li
                                        key={s}
                                        className="flex items-baseline gap-4 text-[#2c2c2a] py-1"
                                    >
                                        <span className="text-[12px] text-[#9a9890] tabular-nums">
                                            {String(i + 1).padStart(2, "0")}
                                        </span>
                                        <span className="text-[16px]">{s}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>

                <div className="mt-20 grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16">
                    <div data-testid="certs-block" className="border-t border-[#0e0e0c] pt-6">
                        <h3
                            className="font-serif text-2xl md:text-3xl text-[#0e0e0c] mb-7"
                            style={{ fontWeight: 400 }}
                        >
                            Certifications
                        </h3>
                        <ul className="space-y-3">
                            {CERTS.map((c) => (
                                <li
                                    key={c}
                                    className="flex gap-4 text-[#2c2c2a] text-[16px] py-1"
                                >
                                    <span className="text-[#9a9890]">—</span>
                                    {c}
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div data-testid="langs-block" className="border-t border-[#0e0e0c] pt-6">
                        <h3
                            className="font-serif text-2xl md:text-3xl text-[#0e0e0c] mb-7"
                            style={{ fontWeight: 400 }}
                        >
                            Langues
                        </h3>
                        <ul className="space-y-5">
                            {LANGS.map((l) => (
                                <li key={l.name} className="flex flex-col">
                                    <span className="font-serif text-xl text-[#0e0e0c]">
                                        {l.name}
                                    </span>
                                    <span className="text-sm text-[#6b6b66] italic-serif mt-1">
                                        {l.level}
                                    </span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    );
}
